export default [
  // Captações
  {
    path: 'operacoes-financeiras/captacoes/entrada-captacoes',
    name: 'operacoesFinanceiras_captacoes_entradaCaptacoes',
    component: () => import(/* webpackChunkName: "EntradaDeCaptacoes" */ '@/views/modules/operacoesFinanceiras/captacoes/EntradaDeCaptacoes'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.captacoes.entradaDeCaptacoes',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/captacoes/captacoes-em-aberto',
    name: 'operacoesFinanceiras_captacoes_captacoesEmAberto',
    component: () => import(/* webpackChunkName: "CaptacoesEmAberto" */ '@/views/modules/operacoesFinanceiras/captacoes/CaptacoesEmAberto'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.captacoes.captacoesEmAberto',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/captacoes/captacoes-efetivadas',
    name: 'operacoesFinanceiras_captacoes_captacoesEfetivadas',
    component: () => import(/* webpackChunkName: "CaptacoesEfetivadas" */ '@/views/modules/operacoesFinanceiras/captacoes/CaptacoesEfetivadas'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.captacoes.captacoesEfetivadas',
      tab: true,
    },
  },

  // Parametrização Comum
  {
    path: 'operacoes-financeiras/parametrizacao-comum/grupo-de-modalidades',
    name: 'operacoesFinanceiras_parametrizacaoComum_grupoDeModalidades',
    component: () => import(/* webpackChunkName: "grupoDeModalidades" */ '@/views/modules/operacoesFinanceiras/ParametrizacaoComum/grupoDeModalidades/index.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.parametrizacaoComum.grupoDeModalidades',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/parametrizacao-comum/carencias',
    name: 'operacoesFinanceiras_parametrizacaoComum_carencias',
    component: () => import(/* webpackChunkName: "carencias" */ '@/views/modules/operacoesFinanceiras/ParametrizacaoComum/carencias.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.parametrizacaoComum.carencias',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/parametrizacao-comum/grupo-de-garantias',
    name: 'operacoesFinanceiras_parametrizacaoComum_grupoDeGarantias',
    component: () => import(/* webpackChunkName: "grupoDeGarantias" */ '@/views/modules/operacoesFinanceiras/ParametrizacaoComum/grupoDeGarantias.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.parametrizacaoComum.grupoDeGarantias',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/parametrizacao-comum/finalidade',
    name: 'operacoesFinanceiras_parametrizacaoComum_finalidade',
    component: () => import(/* webpackChunkName: "finalidade" */ '@/views/modules/operacoesFinanceiras/ParametrizacaoComum/finalidade.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.parametrizacaoComum.finalidade',
      tab: true,
    },
  },

  // Covenants
  {
    path: 'operacoes-financeiras/covenants/responsavel-area',
    name: 'operacoesFinanceiras_covenants_responsavelArea',
    component: () => import(/* webpackChunkName: "responsavelArea" */ '@/views/modules/operacoesFinanceiras/Covenants/responsavelArea.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.covenants.responsavelArea',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/covenants/responsavel-emitente',
    name: 'operacoesFinanceiras_covenants_responsavelEmitente',
    component: () => import(/* webpackChunkName: "responsavelEmitente" */ '@/views/modules/operacoesFinanceiras/Covenants/responsavelEmitente.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.covenants.responsavelEmitente',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/covenants/responsavel-receptor',
    name: 'operacoesFinanceiras_covenants_responsavelReceptor',
    component: () => import(/* webpackChunkName: "responsavelReceptor" */ '@/views/modules/operacoesFinanceiras/Covenants/responsavelReceptor.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.covenants.responsavelReceptor',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/covenants/agrupamento',
    name: 'operacoesFinanceiras_covenants_agrupamento',
    component: () => import(/* webpackChunkName: "agrupamento" */ '@/views/modules/operacoesFinanceiras/Covenants/agrupamento.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.covenants.agrupamento',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/covenants/obrigacao',
    name: 'operacoesFinanceiras_covenants_obrigacao',
    component: () => import(/* webpackChunkName: "obrigacao" */ '@/views/modules/operacoesFinanceiras/Covenants/obrigacao.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.covenants.obrigacao',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/covenants/acao',
    name: 'operacoesFinanceiras_covenants_acao',
    component: () => import(/* webpackChunkName: "acao" */ '@/views/modules/operacoesFinanceiras/Covenants/acao.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.covenants.acao',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/covenants/schedule',
    name: 'operacoesFinanceiras_covenants_schedule',
    component: () => import(/* webpackChunkName: "schedule" */ '@/views/modules/operacoesFinanceiras/Covenants/schedule.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.covenants.schedule',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/covenants/tipo-de-covenants',
    name: 'operacoesFinanceiras_covenants_tipoDeCovenants',
    component: () => import(/* webpackChunkName: "tipoDeCovenants" */ '@/views/modules/operacoesFinanceiras/Covenants/tipoDeCovenants.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.covenants.tipoDeCovenants',
      tab: true,
    },
  },

  // Marcação a Mercado
  {
    path: 'operacoes-financeiras/marcacao-mercado/taxa-de-marcacao-mercado',
    name: 'operacoesFinanceiras_marcacaoMercado_taxaDeMarcacaoAMercado',
    component: () => import(/* webpackChunkName: "taxadeMarcacaoMercado" */ '@/views/modules/operacoesFinanceiras/MarcacaoMercado/taxadeMarcacaoMercado.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.marcacaoMercado.taxaDeMarcacaoAMercado',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/marcacao-mercado/classificacao-agente',
    name: 'operacoesFinanceiras_marcacaoMercado_classificacaoAgente',
    component: () => import(/* webpackChunkName: "classificacaoAgente" */ '@/views/modules/operacoesFinanceiras/MarcacaoMercado/classificacaoAgente.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.marcacaoMercado.classificacaoAgente',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/marcacao-mercado/taxas-curva-credito',
    name: 'operacoesFinanceiras_marcacaoMercado_taxasCurvaCredito',
    component: () => import(/* webpackChunkName: "taxasCurvaCredito" */ '@/views/modules/operacoesFinanceiras/MarcacaoMercado/taxasCurvaCredito.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.marcacaoMercado.taxasCurvaCredito',
      tab: true,
    },
  },

  // Workflow
  {
    path: 'operacoes-financeiras/workflow/limites',
    name: 'operacoesFinanceiras_workflow_limites',
    component: () => import(/* webpackChunkName: "limites" */ '@/views/modules/operacoesFinanceiras/WorkFlowOperacoesFinanceiras/limites.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.workflow.limites',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/workflow/historico-limites',
    name: 'operacoesFinanceiras_workflow_historicoLimites',
    component: () => import(/* webpackChunkName: "historicoLimites" */ '@/views/modules/operacoesFinanceiras/WorkFlowOperacoesFinanceiras/historicoLimites.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.workflow.historicoLimites',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/workflow/historico-exposicao-informada',
    name: 'operacoesFinanceiras_workflow_historicoExposicaoInformada',
    component: () => import(/* webpackChunkName: "historicoExposicaoInformada" */ '@/views/modules/operacoesFinanceiras/WorkFlowOperacoesFinanceiras/historicoExposicaoInformada.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.workflow.historicoExposicaoInformada',
      tab: true,
    },
  },
  {
    path: 'operacoes-financeiras/workflow/exposicao-informada',
    name: 'operacoesFinanceiras_workflow_exposicaoInformada',
    component: () => import(/* webpackChunkName: "exposicaoInformada" */ '@/views/modules/operacoesFinanceiras/WorkFlowOperacoesFinanceiras/exposicaoInformada.vue'),
    meta: {
      middleware: [],
      title: 'modulo.operacoesFinanceiras.workflow.exposicaoInformada',
      tab: true,
    },
  },
];

